import { useMutation, useQueryClient } from 'react-query';
import makeApiRequest from 'services/makeApiRequest';
import apiEndPoints from 'services/apiEndPoints';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useEditEmploymentType(closeModal) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
    
      const response = await makeApiRequest.put(
        apiEndPoints.SETTINGS_EMPLOYMENT_TYPES,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('settings-employment-types');
        SuccessToast({ text: data?.message });
        closeModal();
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
